module.exports = __webpack_public_path__ + "img/C-POWER_DC-DC300W.f9effa8c.jpg";